<template>
  <section class="message-container">
    <span class="title">{{isEdit?'Template':'Message'}}</span>
    <template v-if="!isEdit">
      <div
        v-for="(item,index) in list"
        :key="index">
        <div
          v-for="(mes_item,index) in item.messages"
          :key="'mes_item_'+index"
          class="chat-container flex">
          <span class="">
            <span class="header-icon">
              <template v-if="mes_item.is_customer">
                <img
                  v-if="mes_item.avatar_thumb_url"
                  ref="img"
                  class="img-container"
                  :src="mes_item.avatar_thumb_url">
                <template v-else>
                  <img
                    class="img-container"
                    src="@/assets/images/icon/Personal-icon.png">
                </template>
              </template>
              <img
                v-if="mes_item.is_cs"
                class="img-container"
                :src="mes_item.agency_icon">
            </span>
          </span>
          <div
            class="content flex-1"
            :class="{'content__blue':mes_item.is_cs}"
          >
            <div class="box">
              <span
                v-if="mes_item.is_customer"
                class="flex flex-sb-center">
                <span
                  class="color-dark fs-16 line-24 fw-600">{{mes_item.isrd_nm}}</span>
                <span class="color-gray2 fs-14 line-24">{{mes_item.time}}</span>
              </span>
              <span
                v-if="mes_item.is_cs"
                class="flex flex-sb-center">
                <span
                  class="color-dark fs-16 line-24 fw-600">{{mes_item.cs_name}}</span>
                <span class="color-gray2 fs-14 line-24">{{mes_item.time}}</span>
              </span>
              <p
                class="color-dark fs-14"
                v-html="formatText(mes_item.msg)">
              </p>
            </div>
            <div
              v-for="(file_item,index) in mes_item.files"
              :key="'file_item_'+index"
              class="box flex-sb-center border-top">
              <div class="flex flex-align-center">
                <span class="doc-container">
                  <template v-if="!isVideo(file_item.client_name)">
                    <img
                      class="img-container"
                      :src="file_item.thumb_url">
                    <!--                    <img-->
                    <!--                      v-else-->
                    <!--                      class="img-pdf img-container"-->
                    <!--                      src="@/assets/images/icon/pdf.png">-->
                  </template>
                  <!--                  <template v-else>-->
                  <!--                    &lt;!&ndash;                    <iframe&ndash;&gt;-->
                  <!--                    &lt;!&ndash;                      width="237"&ndash;&gt;-->
                  <!--                    &lt;!&ndash;                      class="video-border"&ndash;&gt;-->
                  <!--                    &lt;!&ndash;                      height="142"&ndash;&gt;-->
                  <!--                    &lt;!&ndash;                      :src="file_item.url"&ndash;&gt;-->
                  <!--                    &lt;!&ndash;                      title="YouTube&ndash;&gt;-->
                  <!--                    &lt;!&ndash;             video&ndash;&gt;-->
                  <!--                    &lt;!&ndash;              player"&ndash;&gt;-->
                  <!--                    &lt;!&ndash;                      frameborder="0"&ndash;&gt;-->
                  <!--                    &lt;!&ndash;                      allow="accelerometer"&ndash;&gt;-->
                  <!--                    &lt;!&ndash;                      autoplay&ndash;&gt;-->
                  <!--                    &lt;!&ndash;                      clipboard-write&ndash;&gt;-->
                  <!--                    &lt;!&ndash;                      encrypted-media&ndash;&gt;-->
                  <!--                    &lt;!&ndash;                      gyroscope&ndash;&gt;-->
                  <!--                    &lt;!&ndash;                      picture-in-picture&ndash;&gt;-->
                  <!--                    &lt;!&ndash;                      web-share&ndash;&gt;-->
                  <!--                    &lt;!&ndash;                      allowfullscreen></iframe>&ndash;&gt;-->
                  <!--                    <video-->
                  <!--                      :src="file_item.url"-->
                  <!--                      controls>-->
                  <!--                    </video>-->
                  <!--                  </template>-->
                </span>
                <span class="color-gray2 fs-14">{{file_item.client_name}}</span>
              </div>
              <span>
                <v-button
                  icon="download"
                  gray
                  @click="handleOpen(file_item.url)">
                </v-button>
              </span>
            </div>
          </div>
        </div>
      </div>
      <div
        v-if="detail.status==3"
        class="chat-container is-resolved flex">
        <span class="">
          <span class="header-icon">
            <img
              class="img-pdf img-container"
              src="@/assets/images/Enquiry-tick.png">
          </span>
        </span>
        <div class="content flex-align-center width-fill">
          <div class="box flex-align-center">
            <p class="color-dark fs-14">
              This Enquiry has been resolved.
            </p>
          </div>
        </div>
      </div>
      <div
        v-if="detail.status==4"
        class="chat-container is-waiting flex">
        <span class="">
          <span class="header-icon">
            <img
              class="img-pdf img-container"
              src="@/assets/images/Enquiry-Pending.png">
          </span>
        </span>
        <div class="content flex-align-center width-fill">
          <div class="box flex-sb-center width-fill">
            <p class="color-dark fs-14">
              Waiting for approval from policyholder
            </p>
            <p
              class="blue pointer"
              @click="handleCopy">Copy SMS Link</p>
          </div>
        </div>
      </div>
      <el-form
        ref="form"
        :rules="rules"
        :model="formData">
        <div
          v-if="detail.status!=3"
          class="chat-container chat-container__send flex">
          <div class="mg-r-16">
            <el-form-item
              prop="agency_id"
            >
              <span class="realtive">
                <span class="header-icon">
                  <img
                    v-if="detail.agency_icon"
                    class="img-container"
                    :src="detail.agency_icon">
                </span>
                <span class="icon-right">
                  <span
                    class="repeat-box"
                    @click="showHandling=true">
                    <font-awesome-icon icon="repeat"></font-awesome-icon>
                  </span>
                </span>
              </span>
            </el-form-item>
          </div>
          <div class="width-fill">
            <div class="form-item width-fill">
              <v-input
                v-model="formData.message"
                type="textarea"
                :maxlength="1000"
                :rows="4"></v-input>
            </div>
            <div
              v-if="formData.files.length>0"
              class="card-table">
              <div
                v-for="(files_item,files_index) in formData.files"
                :key="'files_item_'+files_index"
                class="tr">
                <span
                  class="color-gray60 flie-name-len pointer"
                >{{files_item.client_name}}</span>
                <span class="flex flex-center action-list">
                  <v-upload
                    btnType="text"
                    class="mg-r-15"
                    :otherData="{
                      index: files_index,
                    }"
                    :is-sign="1"
                    is-enquiry
                    label="Replace"
                    @uploadSuccess="handlerUploadReplace"
                  />
                  <span
                    class="color-red fs-14 pointer"
                    @click="handlerDelete(files_index)"
                  >Delete</span>
                </span>
              </div>
            </div>
            <div class="mg-t-20 flex-sb-center">
              <div class="flex">
                <span>
                  <v-upload-list
                    class="mg-r-15"
                    icon="upload"
                    gray
                    :is-sign="1"
                    is-multiple
                    is-enquiry
                    label="Upload"
                    @uploadSuccess="handlerUploadSuccess"
                    @uploadVideoData="uploadVideoData"
                  />
                </span>
                <span class="button-list">
                  <span
                    class="comman btn-gray border-r-none"
                    @click="showTemplate=true">
                    <font-awesome-icon
                      class="mg-r-4"
                      icon="message"></font-awesome-icon>
                    <span>Template</span>
                  </span>
                  <span
                    class="comman btn-gray border-l-none"
                    @click="isEdit=true">
                    <font-awesome-icon
                      class="mg-r-4"
                      icon="pen"></font-awesome-icon>
                    <span>Edit</span>
                  </span>
                </span>
              </div>
              <span>
                <v-button
                  icon="paper-plane"
                  :disabled="!formData.message&&formData.files.length<=0"
                  green
                  @click="handleSend">
                  Send
                </v-button>
              </span>
            </div>
          </div>
        </div>
      </el-form>
    </template>
    <template v-else>
      <enquiry-message-edit @cancel="isEdit = false"></enquiry-message-edit>
    </template>
    <enquiry-template-form
      v-model="showTemplate"
      :message.sync="formData.message"></enquiry-template-form>
    <enquiry-handling-dialog
      v-model="showHandling"
      :agency-id="detail.cs_team_id"
      :detail="detail"
      @refresh="handleRefresh"
    ></enquiry-handling-dialog>
  </section>
</template>

<script>
import EnquiryTemplateForm from './enquiry-template-dialog'
import EnquiryMessageEdit from './enquiry-message-edit'
import {getEnquiryMessageDetail,saveEnquiryMessage,presignedEnquiry,doneEnquiryUpload } from '@/api/enquiry'
import EnquiryHandlingDialog from '@/views/enquiry/compenment/enquiry-handling-dialog'
import MixinOptions from '@/mixins/options'
import MixinFormat from '@/mixins/format'
import MixinRules from '@/mixins/rules'
import {Loading} from 'element-ui'
import axios from 'axios'
import {uploadOrderFile} from '@api/order'
import pdf_icon from '@assets/images/icon/pdf.png'
import {presignedDoneTraveller} from '@api/pop-traveller-team'
import VUploadList from '@/components/control/v-upload-list'
export default {
  name: 'enquiry-message',
  components: { VUploadList,EnquiryHandlingDialog, EnquiryMessageEdit, EnquiryTemplateForm},
  mixins: [MixinOptions, MixinFormat,MixinRules],
  props:{
    detail:{
      type:Object,
      default:()=>({})
    }
  },
  data(){
    return{
      formData:{
        message:'',
        files:[],
        agency_id:0
      },
      showTemplate:false,
      showHandling:false,
      isEdit:false,
      detailData:{}
    }
  },
  computed:{
    enquiry_id(){
      let {id} = this.$route.query
      return id
    },
    list(){
      let {list=[]} = this.detailData||{}
      return list
    },
    isPdf(){
      return (name='')=>{
        let extension =''
        if(name)
          extension = name.split('.').pop().toLowerCase()
        return extension === 'pdf' || extension === 'xls' || extension === 'xlsx'
      }
    },
    isVideo(){
      return (name='')=>{
        let extension =''
        if(name)
          extension = name.split('.').pop().toLowerCase()
        // 定义支持的视频文件后缀
        const videoExtensions = ['.mp4', '.avi', '.mov', '.wmv', '.mkv', '.flv', '.webm']
        return videoExtensions.includes(extension)
      }
    }
  },
  watch:{
    detail:{
      immediate:true,
      handler(val){
        let {agency_id} = val
        this.formData.agency_id = agency_id
      }
    }
  },
  mounted() {
    this.network().getEnquiryMessageDetail()
  },
  methods:{
    handleCopy(){
      let textareaElement = document.createElement('textarea')
      textareaElement.setAttribute('readonly', 'readonly') // 防止弹出输入编辑
      textareaElement .value = this.detailData.verify_sms_link //将需要拷贝的内容设置到textarea元素中。
      document.body.appendChild(textareaElement )
      textareaElement .select() //选中textarea元素，以备调用系统copy函数复制其中的内容。
      let isSuccess = document.execCommand('copy')
      this.$ConfirmBox({
        title: 'Copy Link',
        message: 'The link has been copied to your clipboard',
        confirmBtn:'Done',
        isNewConfirm:true,
        isGreen:true,
        cancelBtn:'',

      })
    },
    handleOpen(url){
      if(url){
        window.open(url, '_blank')
      }
    },
    handleSend(){
      this.$refs['form'].validate(async valid => {
        if(valid){
          await  this.network().saveEnquiryMessage()
          await  this.network().getEnquiryMessageDetail()
        }
      })
    },
    handlerDelete(index) {
      this.formData.files.splice(index,1)
    },
    uploadVideoData(file,{otherData}){
      this.network().presignedEnquiry(file,otherData)
    },
    handlerUploadReplace({data,otherData}) {
      let {index} = otherData
      let files = JSON.parse(JSON.stringify(this.formData.files))
      if (index) {
        // this.formData.files = []
        files[index] = data
        this.formData.files = files
      }
    },
    // handlerUploadSuccess({params,file}) {
    handlerUploadSuccess({data,otherData}) {
      this.formData.files.push({...data})
    },
    handleRefresh(){
      this.network().getEnquiryMessageDetail()
      this.$emit('refresh')
    },
    handleUpload(){

    },
    isVideoFile(file) {
      // 检查文件的 MIME 类型
      return file.type.startsWith('video/')
    },
    network(){
      return{
        getEnquiryMessageDetail:async (params)=>{
          const {data} = await getEnquiryMessageDetail({enquiry_id:this.enquiry_id})
          this.detailData = data

        },
        uploadOrderFile: async (params, result) => {
          this.isLocal = false
          const { data } = await uploadOrderFile(params)
          const { url, isImage } = result
          const dataResult = {
            ...data,
            path: data.name,
            thumb_url:  data.thumb_url
          }
          this.formData.files.push({...dataResult})
        },
        saveEnquiryMessage:async (params)=>{
          const {data} = await saveEnquiryMessage({enquiry_id:this.enquiry_id,...this.formData})
          this.formData = {
            message: '',
            files: [],
            agency_id: this.formData.agency_id
          }
        },
        presignedEnquiry: async (file,otherData) => {
          const { data } = await presignedEnquiry()

          await this.network().postToAmazonS3(data,file,otherData)
        },
        postToAmazonS3: async (params,file,{index}) => {
          try {
            // 构建请求数据
            this.loadinginstace = Loading.service({ fullscreen: true })
            const formData = new FormData()
            formData.append('key', params['key'])
            formData.append('X-Amz-Credential', params['X-Amz-Credential'])
            formData.append('X-Amz-Algorithm', params['X-Amz-Algorithm'])
            formData.append('X-Amz-Date', params['X-Amz-Date'])
            formData.append('Policy', params['Policy'])
            formData.append('X-Amz-Signature', params['X-Amz-Signature'])
            formData.append('file', file)
            // const {data} = await  postToAmazonS3(params)
            // 发送 POST 请求
            const {data} = await axios.post(params.action, formData, {
              headers: {
                'Content-Type': 'multipart/form-data'
              }
            })
            // 处理响应
            if(index){
              this.formData.files[index] = {file,client_name:file.name,id:params.key}
            }else {
              this.formData.files .push({file,client_name:file.name,id:params.key})
            }

            this.loadinginstace.close()
            await  this.network().doneEnquiryUpload({file_id:params.key,filename:file.name})
          } catch (error) {
            console.error(error)
          }
        },
        doneEnquiryUpload: async (params,file) => {
          const { data } = await doneEnquiryUpload(params)
          let {file_size} = data
        },
      }
    }
  }
}
</script>

<style scoped lang="scss">
.message-container{
  .title{
    font-size: 16px;
    font-weight: 600;
    margin-bottom: 24px;
    color: $dark;
  }
  .img-container{
    display: inline-block;
  }
  .line-24{
    line-height: 24px;
  }
  .mg-r-4{
    margin-right: 4px;
  }
  .card-table{
    margin-bottom: 25px;
    border: 1px solid #D1D5DA;
    border-radius:6px;
    .missing {
      color: #91939a;
      font-size: 12px;
      font-style: italic;
    }
    .flie-name-len{
      max-width: 200px;
      white-space: nowrap;
      overflow: hidden;
      text-overflow: ellipsis;
    }
    .tr{
      display: flex;
      justify-content: space-between;
      align-items: center;
      padding: 15px;
      border-bottom:  1px solid #D1D5DA;
      &:last-child{
        border-bottom:0;
      }
      /deep/ .el-upload--text{
        .el-button--mini{
          padding: 0;
        }
        .btn-label{
          font-size: 14px!important;
        }
      }
    }
  }
  .color-red{
    color: #f56c6d;
  }

  .chat-container{
    margin-bottom: 20px;
    &__send{
      padding: 40px 0;
      margin-top: 40px;
      border-top: 1px solid #E6EAEF;
    }
    .header-icon{
      height: 50px;
      width: 50px;
      border-radius: 25px;
      //border: 1px solid #E6EAEF;
      display: block;
      margin-right: 16px;
      overflow: hidden;
      .img-container{
        height: 50px;
      }
    }
    .button-list{
      margin-left: 10px;
      .btn-gray{
        background: #FAFBFC;
        border: 1px solid rgba(27, 31, 35, 0.15);
        -webkit-box-shadow: 0px 1px 0px rgba(27, 31, 35, 0.04);
        box-shadow: 0px 1px 0px rgba(27, 31, 35, 0.04);
        color: #24292E;
        border-radius: 6px;
        font-weight: 600;
        font-size: 14px;
        padding: 7px 15px;
        line-height: 1;
        display: inline-block;
        cursor: pointer;
        &.border-r-none{
          border-right: 0;
          border-top-right-radius: 0;
          border-bottom-right-radius: 0;
        }
        &.border-l-none{
          border-top-left-radius: 0;
          border-bottom-left-radius: 0;
        }
      }
    }
    .mg-r-16{
      margin-right: 16px;
    }
    .realtive{
      position: relative;
      .header-icon{
        margin-right: 0;
      }
      .icon-right{
        position: absolute;
        right: 0px;
        bottom: -4px;
        .repeat-box{
          height: 24px;
          width: 24px;
          font-size: 16px;
          color: #586069;
          border: 1px solid #1B1F2326;
          background: #FAFBFC;
          display: flex;
          align-items: center;
          justify-content: center;
          border-radius: 24px;
          cursor: pointer;
        }
      }
    }

    .content{
      border: 1px solid #D1D5DA;
      border-radius: 0px 16px 16px 16px;
      .box{
        padding: 8px 16px;
        &.border-top{
          border-top: 1px solid #D1D5DA;
          &__blue{
            border-color: #C8E1FF;
          }
        }

        .doc-container{
          width: 58px;
          height: 58px;
          display: block;
          margin-right: 15px;
          border: 1px solid #D1D5DA;
          border-radius: 8px;
          overflow: hidden;
          display: flex;
          justify-content: center;
          align-items: center;
          .img-container{
            width: 58px;
          }
        }
      }
      &__blue{
        border-color: #C8E1FF;
        background: #DBEDFF;
        .box {
          &.border-top{
            border-color: #C8E1FF;
          }
        }
      }
    }
    &.is-resolved{

      .content{
        border: 1px solid #176F2C33;
        background: #DCFFE4;
        border-radius:16px
      }
    }
    &.is-waiting{
      .content{
        background: #fff;
        border-radius:16px
      }
    }
  }
}
</style>
